import { MaybeElement, Node } from './nodes'
import { EditorValue } from './types'
import { walk } from './walk'

export function flatten(value: EditorValue): MaybeElement[] {
  const nodes: Node[] = []
  walk(value, node => nodes.push(node))
  return nodes
}
